export default ['amount', 'cardOnFile', 'storeAsPrimary', 'method', 'source', 'exchangeRateForReport'];
